export const toUpperCase = (str) => str.split(' ').join('').toUpperCase();
